import React from "react";
import "./Button.css";

const Button = (props) => {
  let style = props.dark
    ? "text-gray-600 w-fit anim_button_dark hover:text-white bg-white "
    : "text-white  anim_button hover:text-black bg-black ";

  style += props.extraClass + " ";

  style += props.width !== undefined ? props.width : " w-60";

  return (
    <button
      className={
        props.disabled
          ? "lg:m-0 m-auto lg:inline-block block bg-transparent text-md font-normal  py-1 px-4 border-2 rounded bg-gray-200 text-gray-700"
          : style +
            " lg:m-0 m-auto lg:inline-block block bg-transparent text-md font-normal  py-1 px-4 border-2 rounded "
      }
      disabled={props.disabled}
      onClick={props.handleClick}
    >
      {props.name}
    </button>
  );
};

export default Button;
